<li class="m-navbar-item"
    :class="{'m--is-selected': isSelected,
             'm--is-disabled': disabled }"
    @click="onClick"
    @mouseover="onMouseover"
    @mouseleave="onMouseleave">
    <component class="m-navbar-item__contents"
               :is="isRouterLink ? 'router-link' : 'div'"
               :to="isRouterLink ? url : undefined"
               :tabindex="(url || disabled) ? undefined : '0'"
               :aria-selected="isSelected"
               :aria-haspopup="ariaHaspopup"
               :aria-expanded="ariaExpanded"
               :aria-controls="ariaControls"
               :aria-current="isSelected ? ariaCurrent : undefined"
               ref="item"
               @keyup.enter="onClick">
        <div class="m-navbar-item__text"
             :class="{ 'm--is-nowrap': shouldNotWrap }">
            <div v-if="$slots.leftContain"
                 class="m-navbar-item__text-left-contain">
                <slot name="leftContain" />
            </div>
            <span v-if="formatedLabel"
                  v-html="formatedLabel"
                  ref="itemValue"></span>
            <div v-else-if="$slots.default">
                <slot>{{ value }}</slot>
            </div>
            <div v-if="$slots.rightContain"
                 class="m-navbar-item__text-right-contain">
                <slot name="rightContain" />
            </div>
        </div>
    </component>
</li>
